import * as Redux from 'redux';
import Thunk from 'redux-thunk';

import {configReducer} from './../reducers/configReducer';
import {landlordReducer} from './../reducers/landlordReducer';
import {rentalReducer} from './../reducers/rentalReducer';
import {pageReducer} from './../reducers/pageReducer';
import {messageReducer} from './../reducers/messageReducer';
import {loadingReducer} from './../reducers/loadingReducer';

export var configure = (initialState = {}) => {
	var reducer = Redux.combineReducers({
		config: configReducer,
		landlord: landlordReducer,
		rental: rentalReducer,
		page: pageReducer,
		messages: messageReducer,
		loading: loadingReducer,
	});

	var store = Redux.createStore(reducer, initialState, Redux.compose(
		Redux.applyMiddleware(Thunk),
		window.devToolsExtension ? window.devToolsExtension() : f => f
	));

	return store;
};


// WEBPACK FOOTER //
// ./src/store/configureStore.js